import { registerCustomControlProvider } from '../registry';
import { getGlobalControlsManager } from '../ControlsManager';
// Removed unused sidebar helpers
import { fetchAiCredits } from '~graphql/controllers';
import {
  buildObjectActionsButtons,
  createAiButton,
  createToolsButton,
  createAdjustmentsButton,
} from './shared';
import {
  handleMagicFrameBackgroundColors,
  handleMagicFrameFrameColors,
} from '~core/magicFrame/handleMagicFrameSvgColors';

// Provider for MagicFrame floating controls
registerCustomControlProvider({
  id: 'magicFrame-floating-controls',
  match: (object) => object && object.type === 'MagicFrame',
  create: (manager, magicFrame) => {
    const options = {
      offsetY: 0,
      offsetX: 0,
      gap: 12,
      initialView: 'home',
      views: {
        home: {
          buttons: [
            createAiButton(() => magicFrame),
            {
              text: 'Riposiziona Foto Defunto',
              icon: '🎯',
              className: 'btn-customize',
              role: 'reposition',
              onClick: (event, object, control) => {
                if (object && typeof object.toggleEditMode === 'function') {
                  object.toggleEditMode();
                  control.setEditMode(!!object.isEditing);
                  const cm = getGlobalControlsManager();
                  cm && cm.showControl(object);
                } else if (window.toggleMagicFrameEditMode) {
                  window.toggleMagicFrameEditMode();
                  control.setEditMode(!!object?.isEditing);
                  const cm = getGlobalControlsManager();
                  cm && cm.showControl(object);
                }
              },
            },
            {
              text: 'Sostituisci Foto Defunto',
              icon: '👤',
              className: 'btn-customize',
              onClick: (event, object) => {
                if (window.magicFrameChangePersonPhoto) {
                  window.magicFrameChangePersonPhoto(event, {}, object);
                }
              },
            },
            {
              text: 'Personalizza Cornice',
              icon: '🖼️',
              className: 'btn-customize-frame',
              children: [
                {
                  text: 'Sostituisci Cornice',
                  icon: '🖼️',
                  className: 'btn-replace-frame',
                  onClick: (event, object) => {
                    if (window.magicFrameChangeFramePhoto) {
                      window.magicFrameChangeFramePhoto(event, {}, object);
                    }
                  },
                },
                {
                  text: 'Cambia Colore',
                  inlineSvg:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 3c4.97 0 9 3.582 9 8 0 2.137-1.425 3.5-3.5 3.5h-1.75a.75.75 0 0 0 0 1.5h.75A2.5 2.5 0 1 1 14 19.5h-1c-4.97 0-9-3.582-9-8S7.03 3 12 3Zm-4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-4 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"/></svg>',
                  className: 'btn-customize hide-when-disabled',
                  isEnabled: (target) => !!(target && target.frameSVG),
                  navigateTo: 'frameColors',
                },
                { type: 'divider' },
                {
                  text: 'Rimuovi Cornice',
                  icon: '🗑️',
                  className: 'btn-remove',
                  onClick: (event, object) => {
                    if (object && typeof object.removeFrame === 'function') {
                      object.removeFrame();
                      window.canvas.renderAll();
                    }
                  },
                },
              ],
            },
            {
              text: 'Personalizza Sfondo',
              icon: '🌄',
              className: 'btn-customize-bg',
              children: [
                {
                  text: 'Sostituisci Sfondo',
                  icon: '🌄',
                  className: 'btn-replace-bg',
                  onClick: (event, object) => {
                    if (window.magicFrameChangeBackgroundPhoto) {
                      window.magicFrameChangeBackgroundPhoto(event, {}, object);
                    }
                  },
                },
                {
                  text: 'Cambia Colore',
                  inlineSvg:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 3c4.97 0 9 3.582 9 8 0 2.137-1.425 3.5-3.5 3.5h-1.75a.75.75 0 0 0 0 1.5h.75A2.5 2.5 0 1 1 14 19.5h-1c-4.97 0-9-3.582-9-8S7.03 3 12 3Zm-4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-4 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"/></svg>',
                  className: 'btn-customize hide-when-disabled',
                  isEnabled: (target) => !!(target && target.backgroundSVG),
                  navigateTo: 'backgroundColors',
                },
                { type: 'divider' },
                {
                  text: 'Rimuovi Sfondo',
                  icon: '🗑️',
                  className: 'btn-remove',
                  onClick: (event, object) => {
                    if (
                      object &&
                      typeof object.removeBackground === 'function'
                    ) {
                      object.removeBackground();
                      window.canvas.renderAll();
                    }
                  },
                },
              ],
            },
            { type: 'divider' },
            createToolsButton(() => magicFrame),
            createAdjustmentsButton(() => magicFrame),
            { type: 'divider' },
            {
              text: 'Azioni',
              inlineSvg:
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"></path></svg>',
              className: 'btn-customize',
              children: buildObjectActionsButtons(() => magicFrame),
            },
          ],
        },

        frameColors: {
          title: 'Colori Cornice',
          showBack: true,
          backTo: 'home',
          buttons: [
            { type: 'container', className: 'magicframe-frame-colors' },
          ],
        },
        backgroundColors: {
          title: 'Colori Sfondo',
          showBack: true,
          backTo: 'home',
          buttons: [{ type: 'container', className: 'magicframe-bg-colors' }],
        },
      },
    };

    const ctrl = manager.createFloatingControls(magicFrame, options);

    const updateAiCreditsLabel = async () => {
      try {
        const credits = await fetchAiCredits();
        const total =
          (credits?.edges?.[0]?.freeCreditsAmount || 0) +
          (credits?.edges?.[0]?.paidCreditsAmount || 0);
        const btn = ctrl?.element?.querySelector(
          '.btn-ai-credits .button-text'
        );
        if (btn) btn.textContent = `Crediti (${total})`;
      } catch (e) {
        console.error(
          'Failed updating AI credits label (magicframe control)',
          e
        );
      }
    };
    const renderSvgPanels = () => {
      try {
        handleMagicFrameFrameColors(magicFrame);
      } catch (e) {
        console.error(
          'Failed re-rendering frame colors in floating controls',
          e
        );
      }
      try {
        handleMagicFrameBackgroundColors(magicFrame);
      } catch (e) {
        console.error(
          'Failed re-rendering background colors in floating controls',
          e
        );
      }
    };
    // Initial try after control mount
    setTimeout(renderSvgPanels, 0);
    // Also on any control click (e.g., after navigating views)
    if (typeof ctrl.addClickListener === 'function') {
      ctrl.addClickListener(() => setTimeout(renderSvgPanels, 0));
    }
    // Re-render when control becomes visible again
    if (ctrl && typeof ctrl.show === 'function') {
      const originalShow = ctrl.show.bind(ctrl);
      ctrl.show = () => {
        originalShow();
        setTimeout(renderSvgPanels, 0);
        updateAiCreditsLabel();
      };
    }
    // Re-render when assets load
    magicFrame.on('frame:loaded', renderSvgPanels);
    magicFrame.on('background:loaded', renderSvgPanels);
    // Update credits initially
    setTimeout(updateAiCreditsLabel, 0);
    return ctrl;
  },
});
